import { useEffect } from "react";
import styled from "@emotion/styled";

import { CampaignAccessManagementTable } from "./components/table/CampaignAccessManagementTable";
import { Title as BaseTitle } from "../../ui-components/Typography";
import { successNotification } from "../../ui-components/Notification";
import { NoAccess } from "../../ui-components/NoAccess";

import { setInitialState } from "./store";
import { State } from "../../utils/store";
import { useAppDispatch, useAppSelector } from "../../utils/hooks";
import { UserRole } from "../../auth/store";

export const CampaignAccessManagementView = () => {
  const dispatch = useAppDispatch();

  const { selectedClient } = useAppSelector((state: State) => state.clients);

  const { success } = useAppSelector(
    (state: State) => state.campaignAccessManagement.updateUsersAccess
  );

  useEffect(() => {
    return () => {
      dispatch(setInitialState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      successNotification("Access for users updated successfully");
    }
  }, [success]);

  if (selectedClient?.userRole !== UserRole.ADMIN) {
    return <NoAccess />;
  }

  if (!selectedClient?.contract.hasCampaignAccessManagementEnabled) {
    const noCampaignAccessManagementEnabledErrorMessage =
      "This feature is not enabled in your contract. Please contact a Novable admin if you want to enable or think this is a mistake";
    return (
      <NoAccess errorMessage={noCampaignAccessManagementEnabledErrorMessage} />
    );
  }

  return (
    <Content>
      <SectionHeader>
        <Title>Campaign List</Title>
      </SectionHeader>

      <CampaignAccessManagementTable />
    </Content>
  );
};

const Content = styled.div`
  padding: 2.4rem;
  background-color: var(--white);
`;

const SectionHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const Title = styled(BaseTitle)`
  color: var(--152734);
`;
